const collator = new Intl.Collator('es', {
    numeric: true,
    sensitivity: 'base',
});

function normalizeValue(cell, type) {
    const rawValue = cell?.dataset.sortValue ?? cell?.textContent ?? '';
    const value = rawValue.trim();

    if (value === '' || value === '—' || value.toLocaleLowerCase('es') === 'nunca') {
        return null;
    }

    if (type === 'number') {
        const number = Number(value.replace(/[^0-9,.-]/g, '').replace(',', '.'));
        return Number.isNaN(number) ? null : number;
    }

    if (type === 'date') {
        const timestamp = Date.parse(value.replace(' ', 'T'));
        return Number.isNaN(timestamp) ? null : timestamp;
    }

    return value;
}

function compareValues(first, second, direction) {
    if (first === null && second === null) return 0;
    if (first === null) return 1;
    if (second === null) return -1;

    const result = typeof first === 'string'
        ? collator.compare(first, second)
        : first - second;

    return direction === 'ascending' ? result : -result;
}

function setIcon(icon, name) {
    icon?.querySelector('use')?.setAttribute('href', `#${name}`);
}

function sortTable(table, header) {
    const body = table.tBodies[0];
    if (!body) return;

    const headers = [...header.parentElement.children];
    const columnIndex = headers.indexOf(header);
    const currentDirection = header.getAttribute('aria-sort');
    const direction = currentDirection === 'ascending' ? 'descending' : 'ascending';
    const type = header.dataset.sortType || 'text';

    const rows = [...body.rows].map((row, originalIndex) => ({ row, originalIndex }));
    rows.sort((first, second) => {
        const result = compareValues(
            normalizeValue(first.row.cells[columnIndex], type),
            normalizeValue(second.row.cells[columnIndex], type),
            direction
        );
        return result || first.originalIndex - second.originalIndex;
    });

    headers.forEach(item => {
        item.removeAttribute('aria-sort');
        const icon = item.querySelector('.table-sort__icon');
        setIcon(icon, 'sort');
    });
    header.setAttribute('aria-sort', direction);
    setIcon(
        header.querySelector('.table-sort__icon'),
        direction === 'ascending' ? 'arrow-up' : 'arrow-down'
    );
    header.querySelector('.table-sort__button').setAttribute(
        'aria-label',
        `Ordenar por ${header.querySelector('.table-sort__button span').textContent}, ${direction === 'ascending' ? 'descendente' : 'ascendente'}`
    );
    rows.forEach(({ row }) => body.appendChild(row));
    let counter = 1;
    [...body.rows].forEach(row => {
        const cell = row.querySelector('[data-row-counter]');
        if (cell && !row.hidden) cell.textContent = counter++;
    });
}

export function initSortableTables(root = document) {
    root.querySelectorAll('table[data-sortable-table]').forEach(table => {
        table.querySelectorAll('thead th[data-sort-type]').forEach(header => {
            if (header.querySelector('.table-sort__button')) return;

            const label = header.textContent.trim();
            const button = document.createElement('button');
            button.className = 'table-sort__button';
            button.type = 'button';
            button.innerHTML = `<span>${label}</span><svg class="table-sort__icon icon" aria-hidden="true"><use href="#sort"></use></svg>`;
            button.setAttribute('aria-label', `Ordenar por ${label}`);
            button.addEventListener('click', () => sortTable(table, header));

            header.textContent = '';
            header.appendChild(button);
        });
    });
}
